import * as R from 'ramda'

export const getCommaSeparatedText = (list = []) => {
  if (R.isEmpty(list)) return '-'

  return R.pipe(R.map(R.prop('name')), R.join(', '))(list)
}
